import { render, staticRenderFns } from "./EMCompany.vue?vue&type=template&id=2486b24c&scoped=true&"
import script from "./EMCompany.vue?vue&type=script&lang=js&"
export * from "./EMCompany.vue?vue&type=script&lang=js&"
import style0 from "./EMCompany.vue?vue&type=style&index=0&id=2486b24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2486b24c",
  null
  
)

export default component.exports